import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    box: {
        marginTop: '200px'
    },
    title: {
        fontFamily: 'Montserrat, cursive, Arial '
    }
}));
